import UsefulFunctions from "../../utils/UsefulFunctions";

const calculateSaleData = (product, type) => {
  if (product.isset === 1) {
    let setAmount = 0;
    if (product.setdetails && product.setdetails.length) {
      setAmount = product.setdetails.reduce(
        (totalHolder, item) => totalHolder + item.price * item.buyqty,
        0
      );
    }
    let diffAmt = setAmount - product.price;

    product.setdetails &&
      product.setdetails.map((item) => {
        if (type === "minus") {
          item.qty = item.qty - item.buyqty;
        } else if (type === "plus") {
          item.qty = item.qty === 0 ? item.buyqty : item.qty + item.buyqty;
        } else if (type === "qty") {
          item.qty = product.qty * item.buyqty;
        }

        let procent = Math.round((100 / setAmount) * item.price);
        let discount = Math.round((diffAmt * procent) / 100);
        item.unitdiscount = discount;
        calcualteDiscount(item);
      });
  }
  calcualteDiscount(product);
};

const calcualteDiscount = (product) => {
  if (product) {
    product.amount =
      product.price * product.qty - product.unitdiscount * product.qty;
    product.discount = product.unitdiscount * product.qty;
    product.totalamount = product.price * product.qty;
  }
};

export default function appReducer(state, action) {
  const type = action.type.split("_")[0];
  const model = action.type.split("_")[1];
  switch (type) {
    case "request": {
      if (model !== "kitchenList" && model !== "kitchenfoods") {
        state[`res${model}`] = [];
      }

      state[`is${model}`] = true;

      return { ...state };
    }

    case "error": {
      state[action.type] = action.error;
      state[`err_${model}`] = false;
      return { ...state };
    }

    case "response": {
      state[`res${model}`] = action.response.data;
      state[`is${model}`] = false;
      return { ...state };
    }

    case "login": {
      return {
        products: [],
        notification: false,
        lang: "mn",
        filter: undefined,
        saleList: [],
        order: {},
        errorMsg: "",
        isOpenError: false,
        islogin: action.response,
        _auth: action.response
          ? JSON.parse(localStorage.getItem("auth"))
          : undefined,
      };
    }
    case "products": {
      return { ...state, products: action.response };
    }
    case "filter": {
      return { ...state, filter: action.response };
    }
    case "addSaleList": {
      let product = null;
      if (action.response.isset) {
        let setProduct = state.saleList.filter(
          (a) => a.setid === action.response.setid
        );

        let isValid = false;
        if (setProduct) {
          setProduct.map((set) => {
            isValid = UsefulFunctions.checkSetProducts(
              set.setdetails,
              action.response.setdetails
            );
            if (isValid) {
              product = set;
              return;
            }
          });
        }
      } else {
        product = state.saleList.find(
          (a) =>
            a.productid === action.response.productid &&
            a.spiceid === action.response.spiceid
        );
      }

      if (product) {
        if (action.response.type === "plus") {
          product.qty++;
          calculateSaleData(product, action.response.type);
        } else if (action.response.type === "minus") {
          product.qty--;
          calculateSaleData(product, action.response.type);
        } else if (action.response.type === "discount") {
          product.unitdiscount = action.response.unitdiscount;
          calculateSaleData(product, action.response.type);
        } else if (action.response.type === "qty") {
          product.qty = action.response.qty;
          calculateSaleData(product, action.response.type);
        }
        delete product.type;
      } else {
        calculateSaleData(action.response, action.response.type);
      }

      if (action.response) delete action.response.type;

      return {
        ...state,
        saleList: product
          ? [...state.saleList]
          : [{ ...action.response }, ...state.saleList],
      };
    }
    case "setOrderDetail": {
      return {
        ...state,
        saleList: action.response.detail,
        order: action.response.order,
      };
    }
    case "removeSaleList": {
      let newSaleList = [];
      if (action.response !== "clear") {
        if (action.response.isset === 1) {
          newSaleList = state.saleList.filter((a) => {
            let isValid = UsefulFunctions.checkSetProducts(
              a.setdetails,
              action.response.setdetails
            );
            if (a.setid !== action.response.setid && !isValid) {
              return a;
            }
          });
        } else {
          newSaleList = state.saleList.filter(
            (a) =>
              a.productid !== action.response.productid ||
              a.spiceid !== action.response.spiceid
          );
        }
      }
      return { ...state, saleList: [...newSaleList] };
    }
    case "auth": {
      return {
        ...state,
        _auth: action.response,
      };
    }
    case "notification": {
      return {
        ...state,
        notification: action.response,
      };
    }
    case "setError": {
      return {
        ...state,
        errorMsg: action.response.message,
        isOpenError: action.response.isOpen,
      };
    }
    case "setGuide": {
      return {
        ...state,
        guideContent: action.response,
      };
    }

    default:
      return state;
  }
}
